import React from 'react';
import './CoxProvider.css';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import logo1 from "../../Includes/Images/cox-logo.png";
import provider1 from "../../Includes/Images/banne-image.png";
import provider2 from "../../Includes/Images/Rectangle-4-2.png";
import provider3 from "../../Includes/Images/Group-1000004734-3.png";
import provider4 from "../../Includes/Images/dl-image.png";
import WideCoverage from './WideCoverage';

const CoxProvider = () => {
  return (
    <>
    <Header/>
    <div className="cox-main">
      {/* Header */}
      <div className="cox-header">
        <div className="container">
          <div className="cox-logo">
            <img src={logo1} alt="Cox Authorized Retailer" />
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="cox-hero">
        <div className="container">
          <div className="cox-hero-content">
            <div className="cox-hero-text">
              <h1>
                <span className="text-blue">INTERNET</span>
              </h1>
              <h2>
                <span className="text-blue">SMART<br />WAY TO<br /></span>
                <span className="text-teal">MOBILE</span>
              </h2>
              <div className="cox-price">
                <span className="price-symbol">$</span>
                <span className="price-amount">30</span>
                <span className="price-period">/mo</span>
              </div>
              <p className="cox-qualification">FOR QUALIFYING CUSTOMERS</p>
              <div className="cox-features">
                <h3>Fiber-powered internet</h3>
                <ul>
                  <li>Unlimited data</li>
                  <li>No annual contract</li>
                  <li>Equipment included</li>
                </ul>
              </div>
              <button className="cox-btn cox-btn-primary">
                <i className="phone-icon"></i> +1 (844) 217 2297
              </button>
            </div>
            <div className="cox-hero-image">
              <img src={provider1} alt="Woman using phone" />
            </div>
          </div>
        </div>
      </div>

      {/* Internet Plans Section */}
      <div className="cox-plans-section">
        <div className="container">
          <h3 className="section-label">Internet Plans</h3>
          <h2 className="section-title">Connect with multi<br className="desktop-only" /> GIG download speeds<br className="desktop-only" /> powered by fiber</h2>
          
          <div className="cox-plans-container">
            {/* Plan 1 */}
            <div className="cox-plan-card">
              <div className="plan-header">
                <h3>Go Fast</h3>
                <span className="plan-speed">100 Mbps</span>
              </div>
              <div className="plan-price">
                <span className="price-amount">$30.00</span>
                <span className="price-period">/month</span>
              </div>
              <p className="plan-availability">Starting price not available in all areas. Enter address to check availability.</p>
              <div className="plan-features">
                <p>Great for browsing the web, social media, email, and more</p>
              </div>
              <button className="cox-btn cox-btn-outline">
                <i className="phone-icon"></i> +1 (844) 217 2297
              </button>
            </div>

            {/* Plan 2 */}
            <div className="cox-plan-card featured">
              <div className="plan-badge">POPULAR</div>
              <div className="plan-header">
                <h3>Go Faster</h3>
                <span className="plan-speed">250 Mbps</span>
              </div>
              <div className="plan-price">
                <span className="price-amount">$50.00</span>
                <span className="price-period">/month</span>
              </div>
              <p className="plan-availability">Starting price not available in all areas. Enter address to check availability.</p>
              <div className="plan-features">
                <p>Great for online gaming, working from home, and more</p>
              </div>
              <button className="cox-btn cox-btn-primary">
                <i className="phone-icon"></i> +1 (844) 217 2297
              </button>
            </div>

            {/* Image between plans */}
            <div className="cox-plan-image">
              <img src={provider2} alt="Woman using device" className="plan-side-image" />
            </div>
          </div>

          <div className="cox-plans-container">
            {/* Plan 3 */}
            <div className="cox-plan-card">
              <div className="plan-header">
                <h3>Go Even Faster</h3>
                <span className="plan-speed">500 Mbps</span>
              </div>
              <div className="plan-price">
                <span className="price-amount">$60.00</span>
                <span className="price-period">/month</span>
              </div>
              <p className="plan-availability">Starting price not available in all areas. Enter address to check availability.</p>
              <div className="plan-features">
                <p>Great for 4k video, multi-player gaming, working from home, and more</p>
              </div>
              <button className="cox-btn cox-btn-outline">
                <i className="phone-icon"></i> +1 (844) 217 2297
              </button>
            </div>

            {/* Plan 4 */}
            <div className="cox-plan-card">
              <div className="plan-header">
                <h3>Go Super Fast</h3>
                <span className="plan-speed">1 Gig</span>
              </div>
              <div className="plan-price">
                <span className="price-amount">$70.00</span>
                <span className="price-period">/month</span>
              </div>
              <p className="plan-availability">Starting price not available in all areas. Enter address to check availability.</p>
              <div className="plan-features">
                <p>Great for 8k video, multi-player gaming, working from home, and more</p>
              </div>
              <button className="cox-btn cox-btn-outline">
                <i className="phone-icon"></i> +1 (844) 217 2297
              </button>
            </div>

            {/* Plan 5 */}
            <div className="cox-plan-card">
              <div className="plan-header">
                <h3>Go Beyond Fast</h3>
                <span className="plan-speed">2 Gig</span>
              </div>
              <div className="plan-price">
                <span className="price-amount">$80.00</span>
                <span className="price-period">/month</span>
              </div>
              <p className="plan-availability">Starting price not available in all areas. Enter address to check availability.</p>
              <div className="plan-features">
                <p>Great for multiple video conferences, multi-player gaming, multiple 4k/8k streams, virtual reality, and more</p>
              </div>
              <button className="cox-btn cox-btn-outline">
                <i className="phone-icon"></i> +1 (844) 217 2297
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Affordable Plans Section */}
      <div className="cox-affordable-section">
        <div className="container">
          <div className="affordable-content">
            <h3 className="section-label">Internet Plans</h3>
            <h2 className="section-title">Big internet, small<br className="desktop-only" /> price</h2>
            <p>Low-cost home internet options. Explore our most affordable plans for qualifying households on a tight budget looking for reliable internet.</p>
            <button className="cox-btn cox-btn-primary">
              <i className="phone-icon"></i> +1 (844) 217 2297
            </button>
          </div>
          <div className="affordable-image">
            <img src={provider3} alt="Couple relaxing at home" />
          </div>
        </div>
      </div>

      {/* Service Categories */}
      <div className="cox-services">
        <div className="container">
          <div className="cox-services-header">
            <h2>Let's find what you need</h2>
          </div>
          <div className="cox-service-icons">
            <div className="service-icon">
              <div className="icon-circle">
                <i className="service-icon-wifi"></i>
              </div>
              <span>INTERNET</span>
            </div>
            <div className="service-icon">
              <div className="icon-circle">
                <i className="service-icon-bundle"></i>
              </div>
              <span>POPULAR BUNDLES</span>
            </div>
            <div className="service-icon">
              <div className="icon-circle">
                <i className="service-icon-tv"></i>
              </div>
              <span>TV & STREAMING</span>
            </div>
            <div className="service-icon">
              <div className="icon-circle">
                <i className="service-icon-home"></i>
              </div>
              <span>SMART HOME</span>
            </div>
            <div className="service-icon">
              <div className="icon-circle">
                <i className="service-icon-phone"></i>
              </div>
              <span>HOME PHONE</span>
            </div>
            <div className="service-icon">
              <div className="icon-circle">
                <i className="service-icon-mobile"></i>
              </div>
              <span>MOBILE</span>
            </div>
          </div>
        </div>
      </div>

      {/* Daily Life Section */}
      <div className="cox-daily-life">
        <div className="container">
          <div className="daily-life-image">
            <img src={provider4} alt="Man using phone" />
          </div>
          <div className="daily-life-content">
            <h3 className="section-label">Powering Daily Life</h3>
            <h2 className="section-title">Do more of what you<br className="desktop-only" /> love every day</h2>
            <p>Add at least one Cox Mobile line and you can get a discount on your internet service. That means you'll get fiber-powered internet at home and unbeatable 5G reliability on the go. Once you've finished checking out your internet plan, start shopping for Cox Mobile.</p>
            <p>WiFi life gets easier from the company that has multi GIG download speeds on a fiber-powered network.</p>
            <button className="cox-btn cox-btn-primary">
              <i className="phone-icon"></i> +1 (844) 217 2297
            </button>
          </div>
        </div>
      </div>
      
      {/* Call to Action Section - NEW */}
      <div className="cox-cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to experience better internet?</h2>
            <p>Call now to speak with a Cox representative about our fiber-powered internet plans.</p>
            <button className="cox-btn cox-btn-primary cox-btn-large">
              <i className="phone-icon"></i> +1 (844) 217 2297
            </button>
          </div>
        </div>
      </div>
    </div>
    <WideCoverage/>
    <Footer/>
    </>
  );
};

export default CoxProvider;